// MainLayout.tsx
import { ReactNode, useState, useCallback, useMemo } from 'react';
import { Box, Backdrop, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';

const OPEN_WIDTH = 200;
const CLOSED_WIDTH = 60;

type Props = { children: ReactNode };

export default function MainLayout({ children }: Props) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const sidebarWidth = useMemo(() => (sidebarOpen ? OPEN_WIDTH : CLOSED_WIDTH), [sidebarOpen]);

  return (
    <Box sx={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Sidebar
        open={sidebarOpen}
        openWidth={OPEN_WIDTH}
        closedWidth={CLOSED_WIDTH}
        isMobile={isMobile}
        onClose={() => setSidebarOpen(false)}
      />

      <Box
        sx={{
          ml: { xs: 0, sm: `${sidebarWidth}px` },
          width: { xs: '100vw', sm: `calc(100vw - ${sidebarWidth}px)` },
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Header sidebarOpen={sidebarOpen} onToggleSidebar={toggleSidebar} />

        <Box
          id="app-scroll"
          sx={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            px: 3,
            pb: 4,
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Mobil overlay esetén háttér elsötétítés + kattintásra zárás */}
      <Backdrop
        open={isMobile && sidebarOpen}
        onClick={() => setSidebarOpen(false)}
        // ↓ A backdrop legyen a header fölött, de a sidebar alatt
        sx={{ zIndex: 1599 }}
      />
    </Box>
  );
}
